import { createContext } from 'react';
export var ResolveContext = /*#__PURE__*/createContext(null);
export function assertContext(context) {
  if (context == null) {
    throw Error('ResolveContext.Provider value is required to use hooks');
  }
}
//# sourceMappingURL=context.js.map